import { getIsDesktop } from '@bridebook/web/app-basic/lib/app/selectors';
import { useSelector } from '@bridebook/web/app-basic/lib/utils';
import { useTranslation } from 'next-i18next';
import { ButtonV2 } from '@bridebook/ui';
import { IconShare } from '@bridebook/ui/src/icons';
import SignupLink from '@bridebook/web/app-shared/components/signup-link/signup-link';

const BookmarkButton = () => {
  const { t } = useTranslation('articles');
  const isDesktop = useSelector(getIsDesktop);

  return (
    <SignupLink>
      <ButtonV2 size="small" variant="secondary" endIcon={<IconShare width={12} />}>
        {isDesktop && t('button.share')}
      </ButtonV2>
    </SignupLink>
  );
};

export default BookmarkButton;
